import { Fragment, React } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, CheckboxField, Grid, RadioGroupField, Radio, Flex, Text, TextField, TextAreaField, View, SelectField } from '@aws-amplify/ui-react';
import { handleInteger, handleIntegerBlur, handleSimpleDate, handleSimpleDateBlur, typedReturnValue } from "../anamnese_lib/validateInteger";
import YesNo from "../anamnese_lib/YesNo";
import { DatumToString } from "../../lib/DatumToString";
import StringToDate from "../../lib/StringToDate";
import DatePicker from "react-date-picker";

const ArbeitsAnamnese = (props) => {
    const daten = useSelector(state => state.anamnese.Daten);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        // console.log(e.target)
        const key = e.target.name;
        const val = typedReturnValue(key, e.target.value);
        // console.log(`handleChange ${key} value: ${val} isNumber: ${Number.isInteger(defaultValues[key])}`)
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleCheck = (e) => {
        const key = e.target.name;
        const val = e.target.value === 'on' ? 1 : 0;
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleDate = (e) => {
        // console.log(e);
        const key = e.currentTarget.name;
        const ar = key.split('_');
        const val = DatumToString(e.currentTarget.value);
        const validated = val === 'NaN.NaN.NaN' ? '' : val;
        const ziel = [...daten[`${ar[0]}_${ar[1]}`]]
        ziel[e.currentTarget.index][ar[2]] = validated;
        // console.log(neu)
        // neu[ar[0]][e.currentTarget.index][ar[1]] = val;
        dispatch({ type: 'anamnese/Modify', payload: { [`${ar[0]}_${ar[1]}`]: ziel } });
        props.handleChange({ target: { name: key, value: validated } });
    }

    const handleTextArray = (e) => {
        // console.log(daten)
        const key = e.currentTarget.name;
        const ar = key.split('_');
        const val = e.currentTarget.value;
        const ziel = [...daten[`${ar[0]}_${ar[1]}`]]
        ziel[e.currentTarget.index][ar[2]] = val;
        // console.log(ziel)
        dispatch({ type: 'anamnese/Modify', payload: { [`${ar[0]}_${ar[1]}`]: ziel } });

        props.handleChange({ target: { name: key, value: val } });
    }

    /* rausgeworfen:
            <Flex
                direction={'row'}
            >
                <RadioGroupField
                    value={daten.ARBG_VTZ}
                    onChange={handleChange}
                    descriptiveText=""
                    name="ARBG_VTZ"
                    direction="row">
                    {['keine Angabe', 'Vollzeit', 'Teilzeit'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ARBG_VTZ !== i ? props.readOnly : false}>{item}</Radio>)}
                </RadioGroupField>
            </Flex>
            <p></p>

    */

    return (
        <>
            <h4>2.2 Arbeitsanamnese</h4>
            <p>Ihr Aufenthalt in den Kliniken Dr. Vötisch hat auch das Ziel, Fragen zu Ihrer beruflichen Zukunft zu klären. Bitte beantworten Sie dazu folgende Fragen. </p>

            <h5>Beruflicher Werdegang</h5>
            <h6>Schulbildung</h6>
            <RadioGroupField
                value={daten.SAB}
                onChange={handleChange}
                descriptiveText=""
                alignItems="center"
                name="SAB"
                direction="row">
                {['Hauptschule', 'Sonderschule', 'Mittlere Reife'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.SAB !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.SAB}
                onChange={handleChange}
                descriptiveText=""
                alignItems="center"
                name="SAB"
                direction="row">
                {['Fachhochschulreife', 'Abitur'].map((item, i) => <Radio key={`RG_${i + 3}`} value={i + 3} disabled={daten.SAB !== (i + 3) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h6>Berufsausbildung</h6>
            <RadioGroupField
                value={daten.AUSB}
                onChange={handleChange}
                descriptiveText=""
                name="AUSB"
                direction="row">
                {['angelernt', 'Lehre', 'Studium'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.AUSB !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {daten.AUSB === 0 &&
                <TextField
                    label="als"
                    name="AUSB_ANG"
                    width="100%"
                    defaultValue={daten.AUSB_ANG}
                    onChange={handleChange}
                    direction="row"
                    alignItems="center"
                    maxLength={80}
                    readOnly={props.readOnly}
                />
            }
            {daten.AUSB === 1 &&
                <Flex
                    width="100%"
                    direction="row"
                    gap="1rem"
                    alignItems="center"
                >
                    <Text
                        minWidth="70px"
                    >zum/zur:</Text>
                    <TextField
                        name="LEHR_ZU"
                        width="100%"
                        defaultValue={daten.LEHR_ZU}
                        onChange={handleChange}
                        maxLength={60}
                        readOnly={props.readOnly}
                    />
                </Flex>
            }
            <Flex
                direction="row"
                alignItems="center"
            >
                {daten.AUSB === 2 &&
                    <Flex
                        width="100%"
                        direction="row"
                        gap="1rem"
                        alignItems="center"
                    >
                        <Text
                            minWidth="70px"
                        >als:</Text>
                        <TextField
                            name="STUD_ALS"
                            width="100%"
                            defaultValue={daten.STUD_ALS}
                            onChange={handleChange}
                            maxLength={60}
                            readOnly={props.readOnly}
                        />
                    </Flex>

                }
            </Flex>
            <p></p>
            <Flex
                width="100%"
                direction="row"
                gap="1rem"
                alignItems="center"
            >
                <CheckboxField
                    name="ZUSQ"
                    value={daten.ZUSQ === 1 ? "off" : "on"}
                    checked={daten.ZUSQ === 1}
                    onChange={handleCheck}
                    label="Zusatzqualifikation"
                    disabled={props.readOnly}
                />
                {daten.ZUSQ === 1 &&

                    <TextField
                        name="ZUSQ_TXT"
                        defaultValue={daten.ZUSQ_TXT}
                        width="100%"
                        onChange={handleChange}
                        maxLength={160}
                        readOnly={props.readOnly}
                    />

                }
            </Flex>
            <p></p>
            <Flex
                direction="row"
            >
                <CheckboxField
                    name="UMSCH"
                    value={daten.UMSCH === 1 ? "off" : "on"}
                    checked={daten.UMSCH === 1}
                    onChange={handleCheck}
                    label="Umschulung/Zweitausbildung"
                    disabled={props.readOnly}
                />
                {daten.UMSCH === 1 &&
                    <TextField
                        name="UMSCH_TXT"
                        width="60%"
                        defaultValue={daten.UMSCH_TXT}
                        onChange={handleChange}
                        direction="row"
                        maxLength={60}
                        readOnly={props.readOnly}
                    />
                }
            </Flex>
            <p></p>
            <h6>Frühere Arbeitsplätze/Tätigkeiten</h6>
            <TextAreaField
                name="TAETIGKEITEN"
                width="100%"
                defaultValue={daten.TAETIGKEITEN}
                onChange={handleChange}
                descriptiveText="Geben Sie bitte je Zeile eine frühere Tätigkeit an (die letzten 3 sind ausreichend)"
                wrap="nowrap"
                maxLength={256}
                rows={2}
                readOnly={props.readOnly}
            />
            <p></p>
            <p><b>Arbeitsplatzbeschreibung</b> (bei Arbeitslosigkeit beschreiben Sie bitte Ihren letzten Arbeitsplatz)<br /></p>
            <h6>Genaue Tätigkeit (bzw. letzte Tätigkeit)</h6>
            <TextField
                name="ARBG_ALS"
                defaultValue={daten.ARBG_ALS}
                width="100%"
                maxLength={50}
                onChange={handleChange}
                readOnly={props.readOnly}
            />
            <p></p>
            <h6>Erwerbsstatus</h6>
            <RadioGroupField
                value={daten.BERTYP}
                onChange={handleChange}
                descriptiveText=""
                name="BERTYP"
                direction="row">
                {['angestellt', 'selbständig', 'arbeitslos'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.BERTYP !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.BERTYP}
                onChange={handleChange}
                descriptiveText=""
                name="BERTYP"
                direction="row">
                {['Vorruhestand', 'Altersteilzeit'].map((item, i) => <Radio key={`RG_${i + 3}`} value={i + 3} disabled={daten.BERTYP !== (i + 3) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {(daten.BERTYP === 3 || daten.BERTYP === 4) &&
                <TextField
                    label="seit"
                    defaultValue={daten.BERTYP_DAT}
                    name="BERTYP_DAT"
                    hasError={props.hasError.BERTYP_DAT}
                    errorMessage="Innerhalb der lezten 100 Jahre!"
                    minWidth="40%"
                    placeholder="Jahreszahl?"
                    onChange={(e) => { handleSimpleDate(e, handleChange, props.hasError, props.setHasError) }}
                    onBlur={(e) => { handleSimpleDateBlur(e, props.hasError, props.setHasError) }}
                    direction="row"
                    alignItems="center"
                    maxLength={10}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h6>Jetziger Arbeitgeber (bzw. letzter Arbeitgeber)</h6>
            <TextField
                name="ARBG"
                defaultValue={daten.ARBG}
                width="100%"
                onChange={handleChange}
                maxLength={80}
                readOnly={props.readOnly}
            />
            <p></p>
            <TextField
                label="beschäftigt seit"
                defaultValue={daten.ARBG_DAT}
                name="ARBG_DAT"
                hasError={props.hasError.ARBG_DAT}
                errorMessage="Innerhalb der lezten 100 Jahre!"
                onChange={(e) => { handleSimpleDate(e, handleChange, props.hasError, props.setHasError) }}
                onBlur={(e) => { handleSimpleDateBlur(e, props.hasError, props.setHasError) }}
                placeholder="Jahreszahl?"
                direction="row"
                alignItems="center"
                maxLength={10}
                readOnly={props.readOnly}
            />
            <p></p>
            <TextField
                name="BERUF"
                label="als"
                defaultValue={daten.BERUF}
                onChange={handleChange}
                direction="row"
                alignItems="center"
                maxLength={30}
                readOnly={props.readOnly}
            />
            <p> </p>
            <TextField
                label="Zahl der Mitarbeiter im Betrieb"
                defaultValue={daten.ARBG_ANZ}
                name="ARBG_ANZ"
                hasError={props.hasError.ARBG_ANZ}
                errorMessage="Der Wert muß zwischen 0 und 65534 liegen."
                onChange={(e) => handleInteger(e, handleChange, 0, 65534, props.hasError, props.setHasError)}
                onBlur={(e) => handleIntegerBlur(e, 0, 65534, props.hasError, props.setHasError)}
                direction="row"
                alignItems="center"
                readOnly={props.readOnly}
            />
            <RadioGroupField
                value={daten.ARBG_SIZE}
                onChange={handleChange}
                descriptiveText=""
                name="ARBG_SIZE"
                alignItems="center"
                direction="row">
                {['keine Angabe', 'Zeitarbeitsfirma'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ARBG_SIZE !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.ARBG_SIZE}
                onChange={handleChange}
                descriptiveText=""
                name="ARBG_SIZE"
                alignItems="center"
                direction="row">
                {['befristetes Arbeitsverhältnis'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.ARBG_SIZE !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h6>Arbeitsweg</h6>
            <TextField
                name="ARBWEG"
                label="in km"
                defaultValue={daten.ARBWEG}
                hasError={props.hasError.ARBWEG}
                errorMessage="Der Wert muß zwischen 0 und 400 liegen."
                onChange={(e) => handleInteger(e, handleChange, 0, 400, props.hasError, props.setHasError)}
                onBlur={(e) => handleIntegerBlur(e, 0, 400, props.hasError, props.setHasError)}
                direction="row"
                readOnly={props.readOnly}
            />
            <Text>zurückgelegt:</Text>
            <RadioGroupField
                label=""
                value={daten.ARBWEG_TYP}
                onChange={handleChange}
                descriptiveText=""
                name="ARBWEG_TYP"
                direction="row">
                {['zu Fuß', 'PKW', 'Mofa/Motorrad'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ARBWEG_TYP !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                label=""
                value={daten.ARBWEG_TYP}
                onChange={handleChange}
                descriptiveText=""
                name="ARBWEG_TYP"
                direction="row">
                {['Fahrrad', 'öffentliche Verkehrsmittel'].map((item, i) => <Radio key={`RG_${i + 3}`} value={i + 3} disabled={daten.ARBWEG_TYP !== (i + 3) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h6>Arbeitshaltung:</h6>
            <SelectField
                label="stehend:"
                name="STEHEN"
                value={daten.STEHEN}
                placeholder="bitte auswählen"
                disabled={props.readOnly}
                onChange={handleChange}
                maxWidth="80%"
                direction="row"
            >
                <option value='0'>nicht massgeblich</option>
                <option value='1'>ständig</option>
                <option value='2'>überwiegend</option>
                <option value='3'>zeitweise</option>
            </SelectField>
            <SelectField
                label="gehend:"
                name="GEHEN"
                value={daten.GEHEN}
                placeholder="bitte auswählen"
                disabled={props.readOnly}
                onChange={handleChange}
                maxWidth="80%"
                direction="row"
            >
                <option value='0'>nicht massgeblich</option>
                <option value='1'>ständig</option>
                <option value='2'>überwiegend</option>
                <option value='3'>zeitweise</option>
            </SelectField>
            <SelectField
                label="sitzend:"
                name="SITZEN"
                value={daten.SITZEN}
                placeholder="bitte auswählen"
                disabled={props.readOnly}
                onChange={handleChange}
                maxWidth="80%"
                direction="row"
            >
                <option value='0'>nicht massgeblich</option>
                <option value='1'>ständig</option>
                <option value='2'>überwiegend</option>
                <option value='3'>zeitweise</option>
            </SelectField>
            <SelectField
                label="gebückt:"
                name="BUECKEN"
                value={daten.BUECKEN}
                placeholder="bitte auswählen"
                disabled={props.readOnly}
                onChange={handleChange}
                maxWidth="80%"
                direction="row"
            >
                <option value='0'>nicht massgeblich</option>
                <option value='1'>ständig</option>
                <option value='2'>überwiegend</option>
                <option value='3'>zeitweise</option>
            </SelectField>
            <SelectField
                label="Arme über Brusthöhe:"
                name="UEBERK"
                value={daten.UEBERK}
                placeholder="bitte auswählen"
                disabled={props.readOnly}
                onChange={handleChange}
                maxWidth="80%"
                direction="row"
            >
                <option value='0'>nicht massgeblich</option>
                <option value='1'>ständig</option>
                <option value='2'>überwiegend</option>
                <option value='3'>zeitweise</option>
            </SelectField>
            <SelectField
                label="kniend/hockend:"
                name="KNIEN"
                value={daten.KNIEN}
                placeholder="bitte auswählen"
                disabled={props.readOnly}
                onChange={handleChange}
                maxWidth="80%"
                direction="row"
            >
                <option value='0'>nicht massgeblich</option>
                <option value='1'>ständig</option>
                <option value='2'>überwiegend</option>
                <option value='3'>zeitweise</option>
            </SelectField>
            <SelectField
                label="auf Gerüsten/Leitern:"
                name="STEIGEN"
                value={daten.STEIGEN}
                placeholder="bitte auswählen"
                disabled={props.readOnly}
                onChange={handleChange}
                maxWidth="80%"
                direction="row"
            >
                <option value='0'>nicht massgeblich</option>
                <option value='1'>ständig</option>
                <option value='2'>überwiegend</option>
                <option value='3'>zeitweise</option>
            </SelectField>
            <p></p>
            <h6>Heben/Tragen</h6>
            <Flex direction='row' alignItems='center' >
                <YesNo name="HEBEN" value={daten.HEBEN} onChange={handleChange} readOnly={props.readOnly} />

                {daten.HEBEN === 1 &&
                    <TextField
                        name="HEBEN_ART"
                        label="Art der Lasten:"
                        width="60%"
                        defaultValue={daten.HEBEN_ART}
                        onChange={handleChange}
                        direction="row"
                        alignItems='center'
                        maxLength={80}
                        readOnly={props.readOnly}
                    />
                }
            </Flex  >
            {daten.HEBEN === 1 &&
                <View style={{ marginLeft: '0.5rem' }} >
                    <p></p>
                    <TextField
                        label="Gewichte häufig bis"
                        name="HEBEN_10"
                        defaultValue={daten.HEBEN_10}
                        hasError={props.hasError.HEBEN_10}
                        errorMessage="Der Wert muß zwischen 0 und 150 liegen."
                        onChange={(e) => handleInteger(e, handleChange, 0, 150, props.hasError, props.setHasError)}
                        onBlur={(e) => handleIntegerBlur(e, 0, 150, props.hasError, props.setHasError)}
                        direction="row"
                        readOnly={props.readOnly}
                        outerEndComponent={<Button>kg</Button>}
                    />
                    <TextField
                        label="gelegentlich bis"
                        name="HEBEN_XX"
                        defaultValue={daten.HEBEN_XX}
                        hasError={props.hasError.HEBEN_XX}
                        errorMessage="Der Wert muß zwischen 0 und 150 liegen."
                        onChange={(e) => handleInteger(e, handleChange, 0, 150, props.hasError, props.setHasError)}
                        onBlur={(e) => handleIntegerBlur(e, 0, 150, props.hasError, props.setHasError)}
                        direction="row"
                        readOnly={props.readOnly}
                        outerEndComponent={<Button>kg</Button>}
                    />
                </View>
            }
            {daten.HEBEN === 1 &&
                <View>
                    <p></p>
                    <TextAreaField
                        label="Sind technische Hilfsmittel vorhanden?"
                        name="TECHN_HILF"
                        width="100%"
                        defaultValue={daten.TECHN_HILF}
                        onChange={handleChange}
                        descriptiveText="Welche?"
                        wrap="nowrap"
                        maxLength={256}
                        rows={2}
                        readOnly={props.readOnly}
                    />
                    <p></p>
                    <TextAreaField
                        label="weitere Bemerkungen:"
                        name="HEBEN_SONST"
                        width="100%"
                        defaultValue={daten.HEBEN_SONST}
                        onChange={handleChange}
                        wrap="nowrap"
                        maxLength={256}
                        rows={2}
                        readOnly={props.readOnly}
                    />
                </View>
            }
            <p></p>
            <h6>Arbeitsorganisation</h6>
            <TextField
                name="ARBG_VTZ"
                defaultValue={daten.ARBG_VTZ}
                hasError={props.hasError.ARBG_VTZ}
                errorMessage="Der Wert muß zwischen 0 und 40 liegen."
                onChange={(e) => handleInteger(e, handleChange, 0, 40, props.hasError, props.setHasError)}
                onBlur={(e) => handleIntegerBlur(e, 0, 40, props.hasError, props.setHasError)}
                direction="row"
                label="Arbeitszeit:"
                alignItems="center"
                readOnly={props.readOnly}
                outerEndComponent={<Button>Stunden/Woche</Button>}
            />
            <RadioGroupField
                value={daten.ARBG_ZEITMODELL}
                onChange={handleChange}
                descriptiveText=""
                name="ARBG_ZEITMODELL"
                alignItems="center"
                direction="row">
                {['Ganztagsarbeit', 'Teilzeitarbeit'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ARBG_ZEITMODELL !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.ARBG_ZEITMODELL}
                onChange={handleChange}
                descriptiveText=""
                name="ARBG_ZEITMODELL"
                alignItems="center"
                direction="row">
                {['andere Arbeitszeitmodelle'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.ARBG_ZEITMODELL !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {daten.ARBG_ZEITMODELL === 721 &&
                <TextField
                    name="ARBG_TEILZ_STD"
                    width="15%"
                    defaultValue={daten.ARBG_TEILZ_STD}
                    hasError={props.hasError.ARBG_TEILZ_STD}
                    errorMessage="Der Wert muß zwischen 0 und 40 liegen."
                    onChange={(e) => handleInteger(e, handleChange, 0, 40, props.hasError, props.setHasError)}
                    onBlur={(e) => handleIntegerBlur(e, 0, 40, props.hasError, props.setHasError)}
                    direction="row"
                    label="Stunden/Woche"
                    alignItems="center"
                    readOnly={props.readOnly}
                />
            }
            {daten.ARBG_ZEITMODELL === 2 &&
                <TextField
                    label="welche?"
                    name="ARBG_SONST_TXT"
                    width="60%"
                    defaultValue={daten.ARBG_SONST_TXT}
                    onChange={handleChange}
                    direction="row"
                    maxLength={80}
                    readOnly={props.readOnly}
                />
            }
            <RadioGroupField
                value={daten.ARBG_DIENST}
                onChange={handleChange}
                descriptiveText=""
                name="ARBG_DIENST"
                direction="row">
                {['Normale Arbeitszeit', 'regelmäßige Früh-/Spätschicht'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ARBG_DIENST !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.ARBG_DIENST}
                onChange={handleChange}
                descriptiveText=""
                name="ARBG_DIENST"
                direction="row">
                {['regelmäßige Dreischicht', 'nur Nachtschicht'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.ARBG_DIENST !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <View style={{ marginLeft: '0.5rem' }} >
                <CheckboxField
                    name="ARBG_BAND"
                    value={daten.ARBG_BAND === 1 ? "off" : "on"}
                    checked={daten.ARBG_BAND === 1}
                    onChange={handleCheck}
                    label="starrer, maschinengebundener Arbeitstakt"
                    disabled={props.readOnly}
                />
                <Flex
                    direction='row'
                >
                    <CheckboxField
                        name="ARBG_UEB"
                        value={daten.ARBG_UEB === 1 ? "off" : "on"}
                        checked={daten.ARBG_UEB === 1}
                        onChange={handleCheck}
                        label="Überstunden"
                        disabled={props.readOnly}
                    />
                    {daten.ARBG_UEB === 1 &&
                        <TextField
                            name="ARBG_UEBANZ"
                            width="50%"
                            defaultValue={daten.ARBG_UEBANZ}
                            hasError={props.hasError.ARBG_UEBANZ}
                            errorMessage="Der Wert muß zwischen 0 und 80 liegen."
                            onChange={(e) => handleInteger(e, handleChange, 0, 80, props.hasError, props.setHasError)}
                            onBlur={(e) => handleIntegerBlur(e, 0, 80, props.hasError, props.setHasError)}
                            direction="row"
                            readOnly={props.readOnly}
                            outerEndComponent={<Button>Std./Woche</Button>}
                        />
                    }

                </Flex>
            </View>
            <Flex
                direction='row'
            >
                <RadioGroupField
                    value={daten.ARBG_AKK}
                    onChange={handleChange}
                    descriptiveText=""
                    name="ARBG_AKK"
                    direction="row">
                    {['kein Akkord', 'Einzelakkord', 'Gruppenakkord'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ARBG_AKK !== i ? props.readOnly : false}>{item}</Radio>)}
                </RadioGroupField>
            </Flex>

            <TextField
                label="Beschreibung"
                name="ARBG_BESCHREIBUNG"
                defaultValue={daten.ARBG_BESCHREIBUNG}
                onChange={handleChange}
                maxLength={128}
                readOnly={props.readOnly}
            />
            <p></p>
            <h6>Äußere Einflüsse</h6>
            <Flex direction='row' style={{ marginLeft: '0.5rem' }}>
                <CheckboxField
                    name="KAELTE"
                    value={daten.KAELTE === 1 ? "off" : "on"}
                    checked={daten.KAELTE === 1}
                    onChange={handleCheck}
                    label="Kälte"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="ZUG"
                    value={daten.ZUG === 1 ? "off" : "on"}
                    checked={daten.ZUG === 1}
                    onChange={handleCheck}
                    label="Zugluft"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="NAESSE"
                    value={daten.NAESSE === 1 ? "off" : "on"}
                    checked={daten.NAESSE === 1}
                    onChange={handleCheck}
                    label="Nässe"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HITZE"
                    value={daten.HITZE === 1 ? "off" : "on"}
                    checked={daten.HITZE === 1}
                    onChange={handleCheck}
                    label="Hitze"
                    disabled={props.readOnly}
                />
            </Flex>
            <p></p>
            <Flex direction='row' style={{ marginLeft: '0.5rem' }}>
                <CheckboxField
                    name="STAUB"
                    value={daten.STAUB === 1 ? "off" : "on"}
                    checked={daten.STAUB === 1}
                    onChange={handleCheck}
                    label="starke Staubentwicklung"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="RAUCH"
                    value={daten.RAUCH === 1 ? "off" : "on"}
                    checked={daten.RAUCH === 1}
                    onChange={handleCheck}
                    label="Rauchentwicklung"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex direction='row' style={{ marginLeft: '0.5rem' }}>
                <CheckboxField
                    name="LAERM"
                    value={daten.LAERM === 1 ? "off" : "on"}
                    checked={daten.LAERM === 1}
                    onChange={handleCheck}
                    label="starker Lärm"
                    disabled={props.readOnly}
                />
            </Flex>
            {daten.LAERM === 1 &&
                <CheckboxField
                    name="LAERMSCHUTZ"
                    value={daten.LAERMSCHUTZ === 1 ? "off" : "on"}
                    checked={daten.LAERMSCHUTZ === 1}
                    onChange={handleCheck}
                    label="Lärmschutz muss getragen werden"
                    disabled={props.readOnly}
                />
            }
            <p></p>
            <Flex direction='row' style={{ marginLeft: '0.5rem' }}>
                <CheckboxField
                    name="VIBRATION"
                    value={daten.VIBRATION === 1 ? "off" : "on"}
                    checked={daten.VIBRATION === 1}
                    onChange={handleCheck}
                    label="Erschütterungen/Vibrationen"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="DAMPF"
                    value={daten.DAMPF === 1 ? "off" : "on"}
                    checked={daten.DAMPF === 1}
                    onChange={handleCheck}
                    label="Dämpfe"
                    disabled={props.readOnly}
                />
                {daten.DAMPF === 1 &&
                    <TextField
                        name="DAMPF_TXT"
                        label="welche?"
                        width="60%"
                        defaultValue={daten.DAMPF_TXT}
                        onChange={handleChange}
                        direction="row"
                        alignItems="center"
                        maxLength={128}
                        readOnly={props.readOnly}
                    />
                }
            </Flex>
            <p></p>
            <Flex direction='row' style={{ marginLeft: '0.5rem' }}>
                <CheckboxField
                    name="HAUTREIZUNG"
                    value={daten.HAUTREIZUNG === 1 ? "off" : "on"}
                    checked={daten.HAUTREIZUNG === 1}
                    onChange={handleCheck}
                    label="hautreizende Stoffe"
                    disabled={props.readOnly}
                />
                {daten.HAUTREIZUNG === 1 &&
                    <TextField
                        name="HAUTREIZUNG_TXT"
                        label="welche?"
                        width="60%"
                        defaultValue={daten.HAUTREIZUNG_TXT}
                        onChange={handleChange}
                        direction="row"
                        alignItems="center"
                        maxLength={128}
                        readOnly={props.readOnly}
                    />
                }
            </Flex>
            <p></p>
            <Flex direction='row' style={{ marginLeft: '0.5rem' }}>
                <CheckboxField
                    name="ATEMREIZUNG"
                    value={daten.ATEMREIZUNG === 1 ? "off" : "on"}
                    checked={daten.ATEMREIZUNG === 1}
                    onChange={handleCheck}
                    label="atemreizende Stoffe"
                    disabled={props.readOnly}
                />
                {daten.ATEMREIZUNG === 1 &&
                    <TextField
                        name="ATEMREIZUNG_TXT"
                        label="welche?"
                        width="60%"
                        defaultValue={daten.ATEMREIZUNG_TXT}
                        onChange={handleChange}
                        direction="row"
                        alignItems="center"
                        disabled={props.readOnly}
                    />
                }
            </Flex>
            <p></p>
            <RadioGroupField
                value={daten.ARB_WO}
                onChange={handleChange}
                descriptiveText=""
                name="ARB_WO"
                direction="row">
                {['keine Angabe', 'überwiegend im Freien'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ARB_WO !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.ARB_WO}
                onChange={handleChange}
                descriptiveText=""
                name="ARB_WO"
                direction="row">
                {['überwiegend in Rohbauten', 'überwiegend witterungsgeschützt'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.ARB_WO !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h6>Berufliches Kraftfahren</h6>
            <Flex direction="row">
                <CheckboxField
                    name="PKW"
                    value={daten.PKW === 1 ? "off" : "on"}
                    checked={daten.PKW === 1}
                    onChange={handleCheck}
                    label="PKW"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="LKW"
                    value={daten.LKW === 1 ? "off" : "on"}
                    checked={daten.LKW === 1}
                    onChange={handleCheck}
                    label="LKW"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="BAUMASCHINE"
                    value={daten.BAUMASCHINE === 1 ? "off" : "on"}
                    checked={daten.BAUMASCHINE === 1}
                    onChange={handleCheck}
                    label="Baumaschinen/sonstige"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex direction="row">
                <CheckboxField
                    name="PERSONENBEF"
                    value={daten.PERSONENBEF === 1 ? "off" : "on"}
                    checked={daten.PERSONENBEF === 1}
                    onChange={handleCheck}
                    label="Personenbeförderung"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="GEFAHRGUT"
                    value={daten.GEFAHRGUT === 1 ? "off" : "on"}
                    checked={daten.GEFAHRGUT === 1}
                    onChange={handleCheck}
                    label="Gefahrguttransport"
                    disabled={props.readOnly}
                />
            </Flex>
            <p></p>
            <h6>Sonstiges</h6>
            <Flex direction="row">
                <CheckboxField
                    name="PUBLIKUM"
                    value={daten.PUBLIKUM === 1 ? "off" : "on"}
                    checked={daten.PUBLIKUM === 1}
                    onChange={handleCheck}
                    label="Publikumsverkehr"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="REISE"
                    value={daten.REISE === 1 ? "off" : "on"}
                    checked={daten.REISE === 1}
                    onChange={handleCheck}
                    label="Reisetätigkeit"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex direction="row">

                <CheckboxField
                    name="MONTAGE"
                    value={daten.MONTAGE === 1 ? "off" : "on"}
                    checked={daten.MONTAGE === 1}
                    onChange={handleCheck}
                    label="Auswärts-Montage"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="MITARBEITERFUEHRUNG"
                    value={daten.MITARBEITERFUEHRUNG === 1 ? "off" : "on"}
                    checked={daten.MITARBEITERFUEHRUNG === 1}
                    onChange={handleCheck}
                    label="Mitarbeiterführung"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex direction="row">

                <CheckboxField
                    name="UNFALLGEFAHR"
                    value={daten.UNFALLGEFAHR === 1 ? "off" : "on"}
                    checked={daten.UNFALLGEFAHR === 1}
                    onChange={handleCheck}
                    label="erhöhte Unfallgefahr"
                    disabled={props.readOnly}
                />
            </Flex>
            <p></p>
            <CheckboxField
                name="KONZENTRATION"
                value={daten.KONZENTRATION === 1 ? "off" : "on"}
                checked={daten.KONZENTRATION === 1}
                onChange={handleCheck}
                label="außerordentliche Konzentration erforderlich"
                disabled={props.readOnly}
            />
            <Flex direction="row" alignItems="center">
                <CheckboxField
                    name="ANFAHRTZEIT_YN"
                    value={daten.ANFAHRTZEIT_YN === 1 ? "off" : "on"}
                    checked={daten.ANFAHRTZEIT_YN === 1}
                    onChange={handleCheck}
                    label="lange Anfahrtzeiten"
                    disabled={props.readOnly}
                />
                {daten.ANFAHRTZEIT_YN === 1 &&
                    <>
                        <TextField
                            name="ANFAHRTZEIT"
                            defaultValue={daten.ANFAHRTZEIT}
                            hasError={props.hasError.ANFAHRTZEIT}
                            errorMessage="Der Wert muß zwischen 0 und 400 liegen."
                            placeholder="Minutenanzahl"
                            onChange={(e) => handleInteger(e, handleChange, 0, 400, props.hasError, props.setHasError)}
                            onBlur={(e) => handleIntegerBlur(e, 0, 400, props.hasError, props.setHasError)}
                            readOnly={props.readOnly}
                            outerEndComponent={<Button>Minuten</Button>}
                        />
                    </>
                }
            </Flex>
            <p></p>
            <Flex direction="row">
                <CheckboxField
                    name="OHNEPAUSEN"
                    value={daten.OHNEPAUSEN === 1 ? "off" : "on"}
                    checked={daten.OHNEPAUSEN === 1}
                    onChange={handleCheck}
                    label="keine geregelten Pausen"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="BILDSCHIRMARBEIT"
                    value={daten.BILDSCHIRMARBEIT === 1 ? "off" : "on"}
                    checked={daten.BILDSCHIRMARBEIT === 1}
                    onChange={handleCheck}
                    label="überwiegend Bildschirmarbeit"
                    disabled={props.readOnly}
                />
            </Flex>

            <CheckboxField
                name="SEHVERMOEGEN"
                value={daten.SEHVERMOEGEN === 1 ? "off" : "on"}
                checked={daten.SEHVERMOEGEN === 1}
                onChange={handleCheck}
                label="besondere Anforderungen an das Sehvermögen (z.B. Feinarbeit)"
                disabled={props.readOnly}
            />
            <p></p>
            <h6>Betriebsarzt</h6>
            <Flex direction="row">
                <Text>Ich war beim Betriebsarzt</Text>
                <YesNo name="BETRARZT" value={daten.BETRARZT} onChange={handleChange} readOnly={props.readOnly} />
            </Flex>
            {daten.BETRARZT === 1 &&
                <>
                    <TextField
                        label="zuletzt:"
                        name="BETRARZT_DAT"
                        defaultValue={daten.BETRARZT_DAT}
                        hasError={props.hasError.BETRARZT_DAT}
                        errorMessage="Innerhalb der lezten 100 Jahre!"
                        onChange={(e) => { handleSimpleDate(e, handleChange, props.hasError, props.setHasError) }}
                        onBlur={(e) => { handleSimpleDateBlur(e, props.hasError, props.setHasError) }}
                        placeholder="Jahreszahl?"
                        direction="row"
                        alignItems="center"
                        maxLength={10}
                        readOnly={props.readOnly}
                    />
                    <TextField
                        label="aus welchem Grund?"
                        name="BETRARZT_TXT"
                        defaultValue={daten.BETRARZT_TXT}
                        onChange={handleChange}
                        direction="row"
                        alignItems="center"
                        maxLength={128}
                        readOnly={props.readOnly}
                    />
                </>
            }
            <p></p>
            <h5>Arbeitsunfähigkeit</h5>
            <p>Waren Sie in den letzten 12 Monaten arbeitsunfähig?</p>
            <YesNo name="AU" value={daten.AU} onChange={handleChange} readOnly={props.readOnly} />
            {daten.AU === 1 &&
                <RadioGroupField
                    value={daten.AU_ZEIT}
                    onChange={handleChange}
                    descriptiveText=""
                    name="AU_ZEIT"
                    direction="row">
                    {['bis 6 Wochen', 'bis 3 Monate', 'bis 6 Monate', 'mehr als 6 Monate'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.AU_ZEIT !== i ? props.readOnly : false}>{item}</Radio>)}
                </RadioGroupField>
            }
            {daten.AU === 1 &&
                <>
                    <Grid
                        columnGap="0.1rem"
                        rowGap="0.1rem"
                        templateColumns={{ base: '1fr', large: "1fr 1fr 5fr" }}
                    >
                        <View>
                            <b>von:</b>
                        </View>
                        <View>
                            <b>bis:</b>
                        </View>
                        <View>
                            <b>wegen:</b>
                        </View>

                        {(daten.AU_ZEITEN).map((element, index) => {
                            // console.log(element, index)
                            return (
                                <Fragment key={"F" + index}>

                                    <Flex alignItems="center" key={"F_AU_ZEITEN_VON_" + index} >
                                        <DatePicker
                                            name={"AU_ZEITEN_VON_" + index}
                                            value={StringToDate(element.VON)}
                                            onChange={props.readOnly ? () => { } : (e) => handleDate({ currentTarget: { name: "AU_ZEITEN_VON", index, value: e } })}
                                            locale="de-DE"
                                            format="dd.MM.y"
                                            maxDate={element.BIS > '' ? StringToDate(element.BIS) : new Date()}
                                        />
                                    </Flex>
                                    <Flex alignItems="center" key={"F_AU_ZEITEN_BIS_" + index} >
                                        <DatePicker
                                            name={"AU_ZEITEN_BIS_" + index}
                                            value={StringToDate(element.BIS)}
                                            onChange={props.readOnly ? () => { } : (e) => handleDate({ currentTarget: { name: "AU_ZEITEN_BIS", index, value: e } })}
                                            locale="de-DE"
                                            format="dd.MM.y"
                                            minDate={element.VON > '' ? StringToDate(element.VON) : undefined}
                                            maxDate={new Date()}
                                        />
                                    </Flex>
                                    <TextField
                                        key={"AU_ZEITEN_WEGEN_" + index}
                                        name={"AU_ZEITEN_WEGEN_" + index}
                                        maxLength={128}
                                        defaultValue={element.WEGEN}
                                        onChange={props.readOnly ? () => { } : (e) => handleTextArray({ currentTarget: { name: "AU_ZEITEN_WEGEN", index, value: e.target.value } })}
                                        readOnly={props.readOnly}
                                    />
                                </Fragment>
                            )
                        })}
                    </Grid>
                    <p></p>
                </>
            }
            <p></p>
            <h6>Erwerbsminderungsrente</h6>
            <RadioGroupField
                value={daten.ERWMRENTE}
                onChange={handleChange}
                descriptiveText=""
                name="ERWMRENTE"
                direction="row">
                {['nein', 'ja', 'Antrag gestellt'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ERWMRENTE !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {daten.ERWMRENTE === 1 &&
                <Flex direction="row" alignItems="center">
                    <TextField
                        label="seit"
                        name="ERWMRENTE_DAT"
                        defaultValue={daten.ERWMRENTE_DAT}
                        hasError={props.hasError.ERWMRENTE_DAT}
                        errorMessage="Innerhalb der lezten 100 Jahre!"
                        onChange={(e) => { handleSimpleDate(e, handleChange, props.hasError, props.setHasError) }}
                        onBlur={(e) => { handleSimpleDateBlur(e, props.hasError, props.setHasError) }}
                        placeholder="Jahreszahl?"
                        direction="row"
                        alignItems="center"
                        maxLength={10}
                        readOnly={props.readOnly}
                    />
                    <CheckboxField
                        name="ERWMRENTE_BIS"
                        value={daten.ERWMRENTE_BIS === 1 ? "off" : "on"}
                        checked={daten.ERWMRENTE_BIS === 1}
                        onChange={handleCheck}
                        label="befristet"
                        alignItems="center"
                        disabled={props.readOnly}
                    />
                    {daten.ERWMRENTE_BIS === 1 &&
                        <TextField
                            label="bis"
                            name="ERWMRENTE_BEFR"
                            defaultValue={daten.ERWMRENTE_BEFR}
                            hasError={props.hasError.ERWMRENTE_BEFR}
                            errorMessage="Bis maximal 100 Jahre in der Zukunft!"
                            placeholder="Jahreszahl?"
                            onChange={(e) => { handleSimpleDate(e, handleChange, props.hasError, props.setHasError, 100) }}
                            onBlur={(e) => { handleSimpleDateBlur(e, props.hasError, props.setHasError, 100) }}
                            direction="row"
                            alignItems="center"
                            maxLength={10}
                            readOnly={props.readOnly}
                        />
                    }
                </Flex>
            }
        </>
    )
}

export default ArbeitsAnamnese;